module.exports = __webpack_public_path__ + "img/roundArrow.870a0b11.png";